<app-navbar-style-three></app-navbar-style-three>

<!-- <div class="bg-image">
    <div class="container" style="padding-top: 30px; padding-bottom: 30px;">
        <div class="row">
            <div class="col-md-3" style="font-family: 'HindSiliguri';">
                <div style="padding-left: 20px; align:left">
                    <p style="font-size: 26px">Prospectus</p>
                </div>
                <div class="list-group list-group-flush">
                    <button *ngFor="let item of prospectus" (click)="selectItem(item)"
                        [class.active]="selectedItem === item" style="background-color: transparent !important;"
                        class="newA linkStyle list-group-item list-group-item-action">{{item}}</button>
                </div>
            </div>
            <div class="col-md-9" style="font-family: 'Mohua'; font-size: 4rem;">
                <div style="min-height: 800px;">
                    <div *ngFor="let item of prospectus">
                        <ng-container *ngIf="selectedItem === item">
                            <div *ngIf="item === 'প্রতিষ্ঠাকাল'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <div>
                                        <img class="img-fluid"
                                            style="height: 300px; width: 100%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/1.jpg">
                                    </div>
                                    <br>
                                    <p>
                                       Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi voluptatem beatae saepe doloremque, quas fugiat corrupti repellat quae hic nostrum. Sapiente quisquam, id vero dolores praesentium numquam quas eius amet.
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'অবস্থান'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                       Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa, quia. Ea aliquam debitis optio ab eum esse libero cumque dolores, eos rerum perspiciatis neque consequuntur magnam quisquam omnis quo possimus!
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'লক্ষ্য-উদ্দেশ্য'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                       Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius aperiam aliquam quo iste iure eaque nisi est sit, expedita impedit quis velit tenetur voluptas dignissimos harum ipsam cum laudantium quibusdam?
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'প্রতিষ্ঠানের পাঠ্যক্রম'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                     Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam eos delectus est unde ut expedita fugiat corrupti neque, illum vero ratione, veritatis quo consectetur, soluta impedit? Quam tempore totam cupiditate!
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'সহ-পাঠ্যক্রম কার্যাবলী'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        ★বিতর্ক-সভা <br>
                                        ★শরীর চর্চা <br>
                                        ★শিক্ষাসফর <br>
                                        ★দু‘আ মাহফিল <br>
                                        ★সাহিত্য আসর <br>
                                        ★সাপ্তাহিক জালসাহ <br>
                                        ★পরীক্ষার্থীদের জন্য বিশেষ ক্লাস <br>
                                        ★সাহিত্য আসর ও লেখক কর্মশালা <br>
                                        ★ক্বিরাত, হামদ, নাত ও বক্তৃতার অনুশীলন <br>
                                        ★সাহিত্য-সাময়িকী, বার্ষিকী ও দেয়ালিকা প্রকাশ <br>
                                        ★ভাষা ও অন্যান্য বিষয়ভিত্তিক ক্লাব এর কার্যক্রম <br>
                                        ★বিদেশে উচ্চ শিক্ষায় উৎসাহ ও সহযোগিতা প্রদান <br>
                                        ★শরীয়াহ সম্মত সাংস্কৃতিক অনুষ্ঠান ও ক্রীড়ানুশীলন <br>
                                        ★বার্ষিক দশক বা পক্ষে প্রতিযোগিতামূলক আয়োজন <br>
                                        ★সরকারী-বেসরকারী বিভিন্ন প্রতিযোগিতায় অংশগ্রহণ <br>
                                        ★খতমে বুখারীর (সহীহ বুখারীর সম্পূর্ণ পাঠ) লক্ষ্যে বিশেষ ক্লাস <br>
                                        ★শিক্ষকদের দক্ষতা ও দায়িত্বশীলতা বৃদ্ধির লক্ষ্যে মাদ্রাসা নিজস্ব উদ্যোগে শিক্ষক
                                        প্রশিক্ষণের ব্যবস্থা। <br>
                                    </p>
                                    <div class="imagesGallery">
                                        <img class="img-fluid"
                                            style="height: 300px; width: 20%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/2.jpg">
                                        <img class="img-fluid"
                                            style="height: 300px; width: 20%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/3.jpg">
                                        <img class="img-fluid"
                                            style="height: 300px; width: 20%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/4.jpg">
                                        <img class="img-fluid"
                                            style="height: 300px; width: 20%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/5.jpg">
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item === 'শ্রেণি-বিন্যাস'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        ★ হিফজ  বিভাগে ১ম শ্রেণি থেকে ৫ম শ্রেণির সমন্বয়। <br>
                                        ★ শিশু শ্রেণি থেকে ৫ম শ্রেণি পর্যন্ত ইবতেদায়ী। <br>
                                        ★ দাখিল স্তরে সাধারণ ও বিজ্ঞান বিভাগ | <br>
                                        ★ আলিম স্তরে সাধারণ ও বিজ্ঞান বিভাগ। <br>
                                        ★ ফাজিল পাস (৩ বছর) <br>
                                        ★ অনার্স কোর্স (৪ বছর) <br>
                                        ★ কামিল- হাদীস, তাফসীর ও ফিকহ- (২ বছর) <br>
                                        ★ প্রত্যেক স্তরে প্রয়োজনীয় সেকশন <br>
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'শাখা প্রতিষ্ঠান ও বিভাগসমূহ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                      
                                        ★ তা‘মীরুল মিল্লাত হিফজ বিভাগ <br>
                                        ★ তা‘মীরুল মিল্লাত ছাত্রীনিবাস <br>
                                        ★ তা‘মীরুল মিল্লাত গ্রন্থাগার <br>
                                        ★ তা‘মীরুল মিল্লাত ইফতা বিভাগ <br>
                                        ★ বিজ্ঞানাগার <br>
                                        ★ কম্পিউটার ল্যাব <br>
                                        ★ তাখাস্সুস বিভাগ <br>
                                        ★ ক্বিরাআত বিভাগ <br>
                                        ★ সাহিত্য-সংস্কৃতি বিভাগ <br>
                                        ★ সাহিত্য-সংস্কৃতি বিভাগ <br>
                                        ★ প্রকাশনা বিভাগ <br>
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'তা‘মীরুল মিল্লাত কামিল মাদ্রাসা, বালিকা শাখা'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        মুসলিম মেয়েদের দ্বীনি শিক্ষায় উচ্চ শিক্ষিত করে তোলার অব্যাহত দাবীতে ২০১২ সালে
                                        বালিকা শাখার কার্যক্রম অস্থায়ী ক্যাম্পাসে
                                        শুরু হয়। কম সময়েই এর পরিসর বড় হয়ে উঠে। মাদ্রাসা ক্যাম্পাসের পাশে পৃথক
                                        পরিবেশে তৈরি হয় বালিকা শাখার বিস্তৃত স্থায়ী
                                        ক্যাম্পাস। এখানেও একই পাঠ্যক্রমের অনুসরণে শিশু থেকে কামিল শ্রেণি পর্যন্ত ক্লাস
                                        চালু রয়েছে। দক্ষ ও অভিজ্ঞ শিক্ষিকাদের
                                        মাধ্যমে শরীয়তসম্মত পরিবেশে এখানে পাঠদান অব্যহত আছে।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'তা‘মীরুল মিল্লাত জামে মসজিদ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <div>
                                        <img class="img-fluid"
                                            style="height: 300px; width: 100%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/6.jpg">
                                    </div>
                                    <p>
                                       Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit blanditiis nisi dolorum earum aut repellat architecto facere natus neque cum, beatae praesentium. Itaque sequi nulla illum fugiat quos fuga enim!
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'তা‘মীরুল মিল্লাত হিফজ বিভাগ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        দক্ষ হাফিজে কুরআন তৈরির লক্ষ্যে এ বিভাগ কার্যকর ভূমিকা পালন করছে। যোগ্য ও অভিজ্ঞ
                                        শিক্ষকের তত্তাবধানে প্রতিবছর এখানে অনেক
                                        ছাত্র হিফজুল কুরআন সম্পন্ন করে থাকে।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'তা‘মীরুল মিল্লাত ছাত্রীনিবাস'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        শিক্ষার্থীদের পড়ালেখা ও নৈতিক মান নিশ্চিত করার শুরু থেকে মাদ্রাসা নিজস্ব আবাসিক
                                        ব্যবস্থা রয়েছে। বর্তমানে একটি ছাত্রীহলে প্রায় এক হাজার শিক্ষার্থীর আবাসিক ব্যবস্থা কার্যকর। মেধার
                                        ভিত্তিতে অগ্রাধিকার বিবেচনায় মাদ্রাসার হলে
                                        সিট প্রদান করা হয়। প্রত্যেক হলে ব্লক ভিত্তিক দক্ষ ও অভিজ্ঞ শিক্ষকমণ্ডলীর
                                        নিয়মিত তত্ত্বাবধানে শিক্ষার্থীদের লেখাপড়া ও
                                        নৈতিক মানোন্নয়নের ব্যবস্থা রয়েছে। ছাত্রাবাসের নিয়মাবলীর কঠোর অনুশীলনের মধ্য
                                        দিয়েই শিক্ষার্থীদের এখানে অবস্থান করতে
                                        হয়।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'আবাসন প্রক্রিয়া'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        মাদ্রাসায় ভর্তি হওয়ার পর আগ্রহী শিক্ষার্থীর সাক্ষাৎকার অনুষ্ঠিত হয়।  ছাত্রীনিবাসে সিট খালি থাকা সাপেক্ষে
                                        হোস্টেল অফিস থেকে আবাসিক ফরম সংগ্রহ করে যথাযথ নিয়মে পূরণ করে দুই কপি ছবিসহ জমা
                                        দিতে হয়। একই সাথে নির্দিষ্ট হারে
                                        জামানতসহ সিট ভাড়া ও খাবার চার্জ পরিশোধ করে হোস্টেলে সিট নিশ্চিত করতে হয়।
                                        হোস্টেলে অবস্থানের জন্য চৌকি, টেবিল,
                                        প্রয়োজনীয় বিছানাপত্র ও প্লেট, গ্লাস, বালতি, মগ ইত্যাদি শিক্ষার্থীর নিজ
                                        দায়িত্বে সংগ্রহ করতে হয়।
                                       
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'আবাসন চার্জ'" style="font-family: 'Mohua'; font-size: 1rem;">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card p-4">
                                    <table class="table">
                                        <thead>
                                           
                                        </thead>
                                        <tbody>
                                           
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div *ngIf="item === 'গ্রন্থাগার'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        বৃহৎ পরিসরে মাদ্রাসায় ৩টি লাইব্রেরী বিদ্যমান। প্রাচীন ও আধুনিক কিতাবাদির বিশাল
                                        সংগ্রহ এতে রয়েছে। মূল পাঠ্য কিতাবের
                                        পাশাপাশি রয়েছে প্রয়োজনীয় রেফারেন্স গ্রন্থ। শিক্ষার্থীদের সরাসরি অধ্যয়নের
                                        সাথে সাথে প্রয়োজনে যথানিয়মে লাইব্রেরি
                                        থেকে কিতাব সংগ্রহের ব্যবস্থাও আছে।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'বিজ্ঞানাগার'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        ছাত্রীদের পৃথক ক্যাম্পাসে বিষয়ভিত্তিক আলাদা আলাদা ল্যাব বিদ্যমান।
                                        প্রয়োজনীয় সকল উপকরণবমৃদ্ধ ল্যাবগুলোতে
                                        শিক্ষার্থীদের নিয়মিত ব্যবহারিক ক্লাস করানো হয়। এখানে আবশ্যকীয় ও প্রয়োজনীয় উপকরণ
                                        সংগ্রহ একটি চলমান প্রক্রিয়া।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'কম্পিউটার ল্যাব'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        শিক্ষার্থীদের আইসিটি ও কারিগরি দক্ষতা বৃদ্ধির লক্ষ্যে একটি আলাদা কম্পিউটার ল্যাব
                                        স্থাপন করা হয়েছে। এখানে আছে ৩৬টি
                                        কম্পিউটার।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'তাখাস্সুস বিভাগ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        বাছাইকৃত শিক্ষার্থীদের ইলমী মান উন্নয়ন করে যোগ্য ও দক্ষ আলিমে দ্বীন তৈরি করার
                                        জন্য এ বিভাগটি কাজ করছে। আলিম পর্যায়ের
                                        শিক্ষার্থীদের জন্য বিশেষ পরিকল্পনা গ্রহণ করে এ বিভাগের অধীনে অতিরিক্ত ক্লাসের
                                        ব্যবস্থা করা হয়েছে। ভবিষ্যতে দাখিল
                                        পর্যায়ে এ বিভাগের কাজ সম্প্রসারণের পরিকল্পনা রয়েছে।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'ক্বিরাআত বিভাগ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        শিক্ষার্থীদের কুরআন তিলাওয়াতের বিশুদ্ধি ও আগ্রহী শিক্ষার্থীদের ইলমে কিরাআতে
                                        দক্ষতা বৃদ্ধির জন্য এ বিভাগ কাজ করে থাকে।
                                        অভিজ্ঞ ক্বারীর তত্ত্বাবধানে এ বিভাগের কাজকে আরো জোরদার করার প্রক্রিয়া চলমান
                                        রয়েছে।
                                    </p>
                                </div>
                            </div>
                          
                            <div *ngIf="item === 'সাহিত্য-সংস্কৃতি বিভাগ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>শিক্ষার্থীদের সাহিত্য প্রতিভাকে বিকশিত করার জন্য এ বিভাগ কাজ করে। সাহিত্য আসর,
                                        স্বরচিত লেখা পাঠের আসর, লেখক কর্মশালাসহ
                                        সাংস্কৃতিক বিভিন্ন কার্যক্রমের মাধ্যমে শুদ্ধ সংস্কৃতি ছাত্রজনতার মাঝে ছড়িয়ে
                                        দেয়ার জন্য নানান উদ্যোগ গ্রহণ করা হয়ে
                                        থাকে।
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="item === 'প্রকাশনা বিভাগ'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <div>
                                        <img class="img-fluid"
                                            style="height: 300px; width: 100%; object-fit: cover; border-radius: 10px;"
                                            src="assets/img/school/prospectus/7.jpg">
                                    </div>
                                    <p>লেখালেখির মাধ্যমে সুপ্ত প্রতিভা বিকাশের জন্য এ মাদ্রাসায় রয়েছে
                                        প্রকাশনা বিভাগ। এর অধীনে প্রকাশিত ও প্রকাশমান
                                        বিভিন্ন উপকরণ হলো- <br>
                                        ক. ত্রৈমাসিক তা‘মীরুল মিল্লাত <br>
                                        খ. বার্ষিকী <br>
                                        গ. দাখিল ও আলিম স্মৃতি স্মারক <br>
                                        ঘ. ফাজিল ও কামিল স্মৃতি স্মারক <br>
                                        ঙ. শিক্ষাসফর স্মারক <br>
                                        চ. দেয়ালিকা <br>
                                        ছ. বিষয়ভিত্তিক গ্রন্থ <br>
                                        জ. আরবী ও ইংরেজি সাময়িকী (পরিকল্পনাধীন) <br>
                                    </p>
                                </div>
                            </div>
                           
                            <div *ngIf="item === 'পরীক্ষা ও মূল্যায়ণ পদ্ধতি'">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        সকল শ্রেণিতে সেমিস্টার পদ্ধতিতে পরীক্ষা গ্রহণ করা হয়। বছরে ২টি সেমিস্টার
                                        পরীক্ষা অনুষ্ঠিত হয়। শিশু থেকে নবম শ্রেণিতে
                                        মাসিক পরীক্ষা এবং পাবলিক পরীক্ষার শ্রেণিসমূহে নির্বাচনী ও মডেল পরীক্ষা অনুষ্ঠিত
                                        হয়। সকল পরীক্ষায় ‘আমল-আখলাক’ এর নম্বর
                                        যুক্ত হয়। সকল বিষয়ে উত্তীর্ণ হয়েও আমল-আখলাকে উত্তীর্ণ না হলে অকৃতকার্য
                                        বিবেচিত হয়। তাছাড়া প্রথম সেমিস্টারের সাথে
                                        পরবর্তী সেমিস্টারের নম্বর নির্দিষ্ট হারে সমন্বয় করা হয়।
                                    </p>
                                </div>
                            </div>
                          
                            <div *ngIf="item === 'ভর্তি পরীক্ষা'" style="font-family: 'Mohua'; font-size: 1rem;">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        ★৪র্থ শ্রেণি পর্যন্ত মৌখিক পরীক্ষার মাধ্যমে ভর্তি করা হয়। <br>
                                        ★৫ম থেকে ৯ম শ্রেণি পর্যন্ত ২৫ শে ডিসেম্বর লিখিত ও মৌখিক পরীক্ষায় উত্তীর্ণ
                                        ছাত্র-ছাত্রীদের ভর্তি করা হয়। <br>
                                        ★৯ম বিজ্ঞান বিভাগের জন্য অতিরিক্ত বিজ্ঞান বিষয়ে পরীক্ষা দিতে হয়। <br>
                                        ★ভর্তি পরীক্ষার মোট নম্বর ১০০। তন্মধ্যে লিখিত ৮০ ও মৌখিক ২০। পরীক্ষার সময় ১
                                        ঘণ্টা। <br>
                                        শ্রেণি ভিত্তিক ভর্তি পরীক্ষার বিষয়,মানবণ্টন, নিম্নে দেয়া হলো । <br>
                                    </p>
                                    <b>মানবন্টন</b> <br>
                                    <table style="width:100%">
                                        <tbody>
                                            <tr>
                                                <th>শ্রেণি / বিষয়</th>
                                                <th>আরবি</th>
                                                <th>বাংলা</th>
                                                <th>গণিত</th>
                                                <th>ইংরেজী</th>
                                                <th>সাধারণ জ্ঞান</th>
                                                <th>বিজ্ঞান</th>
                                                <th>মৌখিক</th>
                                            </tr>
                                            <tr>
                                                <td>৫ম - ৯ম (সাধারণ বিভাগ)</td>
                                                <td>২০</td>
                                                <td>১৫</td>
                                                <td>২০</td>
                                                <td>১৫</td>
                                                <td>১০</td>
                                                <td></td>
                                                <td>২০</td>
                                            </tr>
                                            <tr>
                                                <td>৯ম (বিজ্ঞান বিভাগ)</td>
                                                <td>১০</td>
                                                <td>১০</td>
                                                <td>২০</td>
                                                <td>১৫</td>
                                                <td></td>
                                                <td>২৫</td>
                                                <td>২০</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div *ngIf="item === 'ভর্তি প্রক্রিয়া'" style="font-family: 'Mohua'; font-size: 1rem;">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <p>
                                        ক. মাদ্রাসা ওয়েবসাইটে সংরক্ষিত ভর্তির আবেদন ফরমটি সঠিকভাবে পূরণ করে যথানিয়মে
                                        অফিস/ওয়েবসাইট থেকে এন্ট্রি করিয়ে নিতে
                                        হয়। মাদ্রাসার ওয়েবসাইট উল্লেখ্য,
                                        আবেদন ফরমটি পূরণ করার সময় সকল তথ্য সঠিকভাবে দিতে হবে। তথ্যগত কোনো ভুলের
                                        দায় প্রতিষ্ঠান গ্রহণ করবে না। <br>
                                        খ. ভর্তির বাছাই প্রক্রিয়ায় উত্তীর্ণ হলে মাদ্রাসা ভর্তি নিশ্চিত করতে হয়। <br>
                                        গ. ভর্তিতে প্রয়োজনীয় কাগজপত্র <br>
                                    </p>
                                    <table style="width:100%">
                                        <tbody>
                                            <tr>
                                                <th>কাগজপত্র</th>
                                                <th>হিফজ ও শিশু-চতুর্থ</th>
                                                <th>৫ম</th>
                                                <th>৬ষ্ঠ-৭ম</th>
                                                <th>৮ম</th>
                                                <th>৯ম</th>
                                            </tr>
                                            <tr>
                                                <td>ভর্তি ফরম (www.tm.edu.bd ওয়েবসাইট থেকে পূরনকৃত)</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>শিক্ষার্থীর পাসপোর্ট সাইজের রঙিন ছবি (২ কপি)</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>অভিভাবকের NID/Passport এর ফটোকপি</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>শিক্ষার্থীর জন্ম নিবন্ধনের ফটোকপি</td>
                                                <td></td>
                                                <td>✓</td>
                                                <td></td>
                                                <td>✓</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>ছাড়পত্রের মূল কপি</td>
                                                <td></td>
                                                <td></td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>জেডিসির রেজি. কার্ডের ফটোকপি</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>মাদ্রাসার নির্ধারিত ছকে অঙ্গীকারনামা</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>✓</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <b> পুরাতন শিক্ষার্থী</b>
                                    <br>
                                    <table style="width:100%">
                                        <tbody>
                                            <tr>
                                                <th>কাগজপত্র</th>
                                                <th>৫ম</th>
                                                <th>৮ম</th>
                                                <th>৯ম</th>
                                            </tr>
                                            <tr>
                                                <td>ভর্তি ফরম (www.tm.edu.bd ওয়েবসাইট থেকে পূরনকৃত)</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>শিক্ষার্থীর পাসপোর্ট সাইজের রঙিন ছবি (২ কপি)</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>অভিভাবকের NID/Passport এর ফটোকপি</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>শিক্ষার্থীর জন্ম নিবন্ধনের ফটোকপি</td>
                                                <td>✓</td>
                                                <td>✓</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>ছাড়পত্রের মূল কপি</td>
                                                <td></td>
                                                <td>✓</td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>জেডিসির রেজি. কার্ডের ফটোকপি</td>
                                                <td></td>
                                                <td></td>
                                                <td>✓</td>
                                            </tr>
                                            <tr>
                                                <td>মাদ্রাসার নির্ধারিত ছকে অঙ্গীকারনামা</td>
                                                <td></td>
                                                <td></td>
                                                <td>✓</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br> অন্যান্য শ্রেণীর ক্ষেত্রে পুরাতন শিক্ষার্থীরা মোবাইল ব্যাংকিং এর মাধ্যমে
                                    শুধুমাত্র ফি জমা দিবে। <br>
                                    ঘ. প্রযোজ্য শ্রেণিসমূহে মাদ্রাসা নির্দিষ্ট ছকে অঙ্গীকারনামা জমা দিতে হয়।<br>
                                    ঙ. নির্দিষ্ট হারে ভর্তি ফিসহ সকল লেনদেন শিক্ষার্থীর mCash/CellFin একাউন্টের মাধ্যমে
                                    পরিশোধ করতে হয়।<p></p><br>
                                </div>
                            </div>
                            <div *ngIf="item === '২০২৩ শিক্ষাবর্ষে ভর্তি ফি ও বেতন কাঠামো'"
                                style="font-family: 'Mohua'; font-size: 1rem;">
                                <h3>{{item}}</h3>
                                <hr>
                                <div class="container card" style="padding: 20px;">
                                    <table id="dataTable">
                                        <thead>
                                            <tr>
                                                <th>ক্রম</th>
                                                <th>শ্রেণি</th>
                                                <th>ছাত্র (নতুন)</th>
                                                <th>ছাত্র (পুরাতন)</th>
                                                <th>ছাত্র বেতন</th>
                                                <th>ছাত্রী (নতুন)</th>
                                                <th>ছাত্রী (পুরাতন)</th>
                                                <th>ছাত্রী বেতন</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>শিশু-৪র্থ</td>
                                                <td>5050</td>
                                                <td>4350</td>
                                                <td>350</td>
                                                <td>5010</td>
                                                <td>4400</td>
                                                <td>400</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>৫ম</td>
                                                <td>5050</td>
                                                <td>4350</td>
                                                <td>350</td>
                                                <td>5100</td>
                                                <td>4400</td>
                                                <td>400</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>৬ষ্ঠ-৭ম</td>
                                                <td>5050</td>
                                                <td>4350</td>
                                                <td>350</td>
                                                <td>5100</td>
                                                <td>4400</td>
                                                <td>400</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>৮ম</td>
                                                <td>5050</td>
                                                <td>4350</td>
                                                <td>350</td>
                                                <td>5100</td>
                                                <td>4400</td>
                                                <td>400</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>৯ম (সাধারণ)</td>
                                                <td>5050</td>
                                                <td>4350</td>
                                                <td>350</td>
                                                <td>5100</td>
                                                <td>4400</td>
                                                <td>400</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>৯ম (বিজ্ঞান)</td>
                                                <td>6300</td>
                                                <td>5600</td>
                                                <td>400</td>
                                                <td>6350</td>
                                                <td>5650</td>
                                                <td>45000</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>১০ম (সাধারণ)</td>
                                                <td>-</td>
                                                <td>4350</td>
                                                <td>350</td>
                                                <td>-</td>
                                                <td>4400</td>
                                                <td>400</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>১০ম (বিজ্ঞান)</td>
                                                <td>-</td>
                                                <td>5600</td>
                                                <td>400</td>
                                                <td>-</td>
                                                <td>5650</td>
                                                <td>450</td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>হিফজ</td>
                                                <td>5150</td>
                                                <td>4450</td>
                                                <td>450</td>
                                                <td>-</td>
                                                <td>-</td>
                                                <td>-</td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>আলিম সাধারণ</td>
                                                <td>4300</td>
                                                <td>-</td>
                                                <td>350</td>
                                                <td>435000</td>
                                                <td>-</td>
                                                <td>40000</td>
                                            </tr>
                                            <tr>
                                                <td>11</td>
                                                <td>আলিম বিজ্ঞান</td>
                                                <td>5350</td>
                                                <td>-</td>
                                                <td>400</td>
                                                <td>540000</td>
                                                <td>-</td>
                                                <td>45000</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    বি: দ্র: প্রয়োজনে বেতন ও অন্যান্য চার্জ পরিবর্তনশীল।
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->